import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./FoodDetails.css";
import getImageUrl from "../../utils/imageUrl";
function FoodDetails() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [food, setFood] = useState(null);

  const [reviews, setReviews] = useState([]);

  const [averageRating, setAverageRating] =
    useState(0);

  const [totalReviews, setTotalReviews] =
    useState(0);

  const [rating, setRating] =
    useState("5");

  const [comment, setComment] =
    useState("");

  useEffect(() => {

    fetchFood();
    fetchReviews();
    fetchRating();

  }, [id]);

  // =============================
  // Food
  // =============================

  const fetchFood = async () => {

    try {

      const res = await API.get(
        `/food/${id}`
      );

      setFood(res.data.food);

    } catch (error) {

      console.log(error);

    }

  };

  // =============================
  // Reviews
  // =============================

  const fetchReviews = async () => {

    try {

      const res = await API.get(
        `/reviews/${id}`
      );

      setReviews(res.data.reviews);

    } catch (error) {

      console.log(error);

    }

  };

  // =============================
  // Rating
  // =============================

  const fetchRating = async () => {

    try {

      const res = await API.get(
        `/reviews/rating/${id}`
      );

      setAverageRating(
        res.data.averageRating
      );

      setTotalReviews(
        res.data.totalReviews
      );

    } catch (error) {

      console.log(error);

    }

  };

  // =============================
  // Buy Now
  // =============================

 const handlePlaceOrder = async () => {

    try {

      const token =
        localStorage.getItem("token");

      const res = await API.post(

        "/cart/add",

        {
          foodId: food._id
        },

        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

      );

      alert(res.data.message);

      navigate("/cart");

    } catch (error) {

      console.log(error);

      alert(
        error.response?.data?.message ||
        "Unable to Buy Now"
      );

    }

  };

  

  // =============================
  // Favorite
  // =============================

  const handleFavorite = async () => {

    try {

      const token =
        localStorage.getItem("token");

      const res = await API.post(

        "/favorites",

        {
          foodId: food._id
        },

        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

      );

      alert(res.data.message);

    } catch (error) {

      alert(
        error.response?.data?.message ||
        "Failed"
      );

    }

  };

  // =============================
  // Review
  // =============================

  const handleReview = async () => {

    try {

      const token =
        localStorage.getItem("token");

      await API.post(

        "/reviews",

        {
          foodId: food._id,
          rating: Number(rating),
          comment
        },

        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }

      );

      alert("Review Added");

      setComment("");

      setRating("5");

      fetchReviews();

      fetchRating();

    } catch (error) {

      console.log(error);

      alert("Review Failed");

    }

  };

  if (!food) {

    return <h2>Loading...</h2>;

  }

    return (

    <div className="food-details-container">

      <div className="food-details-card">

        {/* Food Image */}

        <div className="food-image-section">

         <img
  className="food-image-large"
  src={
    getImageUrl(food.image) ||
    "/images/food-placeholder.png"
  }
  alt={food.foodName || "Food"}
  onError={(e) => {
    e.currentTarget.src =
      "/images/food-placeholder.png";
  }}
/>

        </div>

        {/* Food Information */}

        <div className="food-info-section">

          <h1>{food.foodName}</h1>

          <p
            style={{
              color: "#ff9800",
              fontWeight: "bold",
              fontSize: "18px"
            }}
          >
            ⭐ {averageRating}/5
            ({totalReviews} Reviews)
          </p>

          <p className="food-description">

            {food.description}

          </p>

          <div className="food-meta">

            <p>

              <strong>Category :</strong>

              {" "}

              {food.category}

            </p>

            <p>

              <strong>Food Type :</strong>

              {" "}

              {

                food.foodType === "Veg"

                  ?

                  "🟢 Veg"

                  :

                  "🔴 Non Veg"

              }

            </p>

            <p>

              <strong>Preparation :</strong>

              {" "}

              {food.preparationTime} mins

            </p>

            <p>

              <strong>Availability :</strong>

              {" "}

              {

                food.isAvailable

                  ?

                  "✅ Available"

                  :

                  "❌ Not Available"

              }

            </p>

          </div>

          <div className="price-box">

            {

              food.offerPrice > 0

                ?

                <>

                  <h2
                    style={{
                      color:"#ff6b35"
                    }}
                  >
                    ₹{food.offerPrice}
                  </h2>

                  <del
                    style={{
                      color:"#999"
                    }}
                  >
                    ₹{food.price}
                  </del>

                </>

                :

                <h2
                  style={{
                    color:"#ff6b35"
                  }}
                >
                  ₹{food.price}
                </h2>

            }

          </div>

          {/* Buttons */}

         <div className="food-buttons">

    <button
        className="buy-btn"
        onClick={handlePlaceOrder}
    >
        🛒 Place Order
    </button>

</div>
        </div>

      </div>

      <hr />

      {/* Review Section */}

      <div className="review-box">

        <h2>

          ⭐ Add Review

        </h2>

        <select

          value={rating}

          onChange={(e)=>

            setRating(e.target.value)

          }

        >

          <option value="5">

            ⭐⭐⭐⭐⭐

          </option>

          <option value="4">

            ⭐⭐⭐⭐

          </option>

          <option value="3">

            ⭐⭐⭐

          </option>

          <option value="2">

            ⭐⭐

          </option>

          <option value="1">

            ⭐

          </option>

        </select>

        <textarea

          className="review-textarea"

          placeholder="Write your review..."

          value={comment}

          onChange={(e)=>

            setComment(e.target.value)

          }

        />

        <button

          className="submit-review-btn"

          onClick={handleReview}

        >

          Submit Review

        </button>

      </div>

      <hr />

      <h2>

        Customer Reviews

      </h2>

            {

        reviews.length === 0

        ?

        <div className="no-reviews">

          <p>

            No reviews yet.

          </p>

        </div>

        :

        reviews.map((review) => (

          <div

            className="review-card"

            key={review._id}

          >

            <div className="review-header">

              <h4>

                👤 {review.userId?.name || "Anonymous"}

              </h4>

              <span>

                ⭐ {review.rating}/5

              </span>

            </div>

            <p>

              {review.comment}

            </p>

            <small>

              {

                new Date(

                  review.createdAt

                ).toLocaleDateString()

              }

            </small>

          </div>

        ))

      }

    </div>

  );

}

export default FoodDetails;